import React from 'react';
import { localization } from './localization';
import { Subtitle } from '../../EmptyState/styles';
import { useContentLocalizer } from '../../../hooks/useContentLocalizer';
import { BdsButton, BdsGrid, BdsIcon, BdsTypo } from 'blip-ds/dist/blip-ds-react';

interface LoadErrorStateProps {
  onTryAgain?: () => void;
}

const LoadErrorState: React.FC<LoadErrorStateProps> = ({ onTryAgain }) => {
  const translate = useContentLocalizer(localization);

  return (
    <BdsGrid direction="column" align-items="center" gap="3" padding="3" justify-content="center">
      <BdsIcon name="refresh" />
      <BdsGrid direction="column" gap="1" align-items="center" justify-content="center">
        <BdsTypo variant="fs-20" bold="bold" margin={false}>
          {translate.title}
        </BdsTypo>
        <Subtitle>
          <BdsTypo variant="fs-14">{translate.subtitle}</BdsTypo>
        </Subtitle>
      </BdsGrid>
      <BdsButton size="short" variant="outline" color="Content" onClick={onTryAgain}>
        {translate.tryAgain}
      </BdsButton>
    </BdsGrid>
  );
};

export default LoadErrorState;
